import { gql } from "@apollo/client";
import { useSuspenseQuery } from "@apollo/client/react";

import GQLApplications from "./Applications.graphql";
import Application, { ApplicationStruct } from "../../features/applications/domain/Application";

export default function useApplications() {
    const query = useSuspenseQuery<ApplicationsQueryResult>(
        gql(GQLApplications),
    );
    return query.data.applications.map(
        (application) => new Application(application),
    );
}

interface ApplicationsQueryResult {
    applications: ApplicationStruct[]
}
